/**
 * Public marketplace URLs from connector-bound identifiers only.
 * Never use free-text operator fields as the host.
 */

import { parsePublicHttpsOrigin, parseStorefrontProductPath } from "./public-https-origin";

export { parsePublicHttpsOrigin, parseStorefrontProductPath, originFromBcStorePayload, extractBcCustomUrl } from "./public-https-origin";

export function ebayLiveItemUrl(externalListingId: string | null | undefined, marketplaceHost = "www.ebay.com.au"): string | null {
  const id = String(externalListingId ?? "").trim();
  if (!/^\d{9,20}$/.test(id)) return null;
  const host = marketplaceHost.replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  if (!/(^|\.)ebay\.(com|com\.au|co\.uk|de|fr|it|es|ca)$/i.test(host)) return null;
  return `https://${host}/itm/${id}`;
}

export function bigcommerceStorefrontProductUrl(opts: {
  storefrontOrigin: string | null | undefined;
  customUrl?: string | null;
  productId?: number | string | null;
}): string | null {
  const origin = parsePublicHttpsOrigin(opts.storefrontOrigin);
  if (!origin) return null;
  const custom = parseStorefrontProductPath(opts.customUrl);
  if (custom) {
    return `${origin}${custom}`;
  }
  const id = Number(opts.productId);
  if (Number.isInteger(id) && id > 0) return `${origin}/products.php?product_id=${id}`;
  return null;
}

export function bigcommerceAdminProductUrl(opts: {
  storeHash: string | null | undefined;
  productId?: number | string | null;
}): string | null {
  const hash = String(opts.storeHash ?? "").trim();
  if (!/^[a-z0-9]{6,20}$/i.test(hash)) return null;
  const id = Number(opts.productId);
  if (!Number.isInteger(id) || id <= 0) return null;
  return `https://store-${hash}.mybigcommerce.com/manage/products/${id}/edit`;
}

export type LiveLinkKind = "live" | "admin";

export function classifyMarketplaceHref(label: "View live" | "Admin"): LiveLinkKind {
  return label === "View live" ? "live" : "admin";
}
